var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.583,
    height: 21.583,
    viewBox: "0 0 21.583 21.583",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1393",
    "data-name": "Path 1393",
    d: "M1719.063,984.262h-8.249a6.675,6.675,0,0,1-6.667-6.668v-8.248a6.675,6.675,0,0,1,6.667-6.667h8.249a6.675,6.675,0,0,1,6.667,6.667v8.248A6.675,6.675,0,0,1,1719.063,984.262Zm-8.249-19.178a4.267,4.267,0,0,0-4.262,4.262v8.248a4.267,4.267,0,0,0,4.262,4.262h8.249a4.267,4.267,0,0,0,4.262-4.262v-8.248a4.267,4.267,0,0,0-4.262-4.262Z",
    transform: "translate(-1704.147 -962.679)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1394",
    "data-name": "Path 1394",
    d: "M1734.4,998.445a5.516,5.516,0,1,1,5.516-5.516A5.523,5.523,0,0,1,1734.4,998.445Zm0-8.867a3.351,3.351,0,1,0,3.351,3.351A3.355,3.355,0,0,0,1734.4,989.578Z",
    transform: "translate(-1723.607 -982.138)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1395",
    "data-name": "Path 1395",
    d: "M1779.408,982.47a.933.933,0,1,1-.933-.933A.932.932,0,0,1,1779.408,982.47Z",
    transform: "translate(-1761.889 -977.515)",
    fill: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.a991034776b7b4f227ad61841aba11cc.svg";
export { ForwardRef as ReactComponent };